export const ChecklistIcon = () => (
    <span className="checklist-icon">✓</span>
);